import { render, staticRenderFns } from "./teamdetail.vue?vue&type=template&id=d5b73060&scoped=true&"
import script from "./teamdetail.vue?vue&type=script&lang=js&"
export * from "./teamdetail.vue?vue&type=script&lang=js&"
import style0 from "./teamdetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./teamdetail.vue?vue&type=style&index=1&id=d5b73060&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b73060",
  null
  
)

export default component.exports